import { clientSDK } from "@istari-frontend/api-client";

import { readContentQueue } from "~/resource/data-source/file-transfer-config";

import { type BufferedContentMetadata, type ContentReadPurpose, readBufferedContent } from "./read-buffered-content";

export async function readV2RevisionContent(
  revision: BufferedContentMetadata,
  purpose: ContentReadPurpose,
  signal?: AbortSignal,
) {
  const metadata = await resolveV2RevisionMetadata(revision, signal);
  return readBufferedContent(metadata, purpose, signal);
}

// Missing metadata must be completed from this revision's immutable properties, not latest.
export async function resolveV2RevisionMetadata<T extends BufferedContentMetadata>(revision: T, signal?: AbortSignal) {
  const validSize = Number.isSafeInteger(revision.size) && (revision.size ?? -1) >= 0;
  if (validSize || !revision.propertiesToken) return revision;
  signal?.throwIfAborted();
  const { sha, salt } = revision.propertiesToken;
  const properties = await readContentQueue.run(
    () => clientSDK.readProperties(sha, salt, ...(signal ? [{ signal }] : [])),
    signal,
  );
  signal?.throwIfAborted();
  return { ...revision, name: properties.fileName, size: properties.size };
}
